import createModelStore from "../../utils/createModelStore";
import Parking from "../../services/Parking";

const parkings = createModelStore<Parking.Model, "parkings">("parkings");

export default parkings;
